import { cardListSchema, type CardList, type ListCardsQuery } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const searchOf = (query: ListCardsQuery): string =>
  `?${new URLSearchParams({ includeArchived: String(query.includeArchived) }).toString()}`;

const fetchCards = (query: ListCardsQuery, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/cards${searchOf(query)}`, { signal });

export const getCards = async (query: ListCardsQuery, signal: AbortSignal): Promise<CardList> =>
  cardListSchema.parse(await fetchCards(query, signal));
